import React from "react";
import FormattedDate from "./formattedDate";
import WeatherTemperature from "./weatherTemperature";
import WeatherIcon from "./weatherIcon";

export default function CurrentWeather(props) {
  return (
    <div className="overview">
      <div className="row todayforecast">
        <div className="col-6 selectcity">
          <h2 id="city-name">{props.data.city}</h2>
          <div className="row cityforecast">
            <div className="col currentday" id="current-day">
              <FormattedDate date={props.data.date} />
            </div>
            <div className="col currentforecast" id="forecast">
              {props.data.description}
            </div>
            <br />
            <div className="col weatherconditions">
              <ul>
                <li>
                  Humidity: <span id="humidity">{props.data.humidity}</span>%
                </li>
                <li>
                  Wind speed: <span id="wind-speed">{props.data.wind}</span>{" "}
                  km/h
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col currenttemperature">
          <WeatherTemperature celsius={props.data.temperature} />
          <div className="weathericon">
            <WeatherIcon code={props.data.icon} />
          </div>
        </div>
      </div>
    </div>
  );
}
